import { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { H4, Image, LI, UL } from "../../../AbstractElements";
import { dynamicImage } from "../../../Utils";

import SvgIcon from "../../../Utils/CommonComponents/CommonIcons/CommonSvgIcons";
import LogoutModal from "../../../Auth/LogoutModal";

import { backendbaseUrl } from "../../../Utils/baseUrl";
import { toast } from "react-toastify";
import { useQuery } from '@tanstack/react-query';
import axiosInstance from "../../../Utils/axiosInstance";
import { fetchCurrentUserData } from "../../../api/common";
export default function ProfileHeader() {
  const navigate = useNavigate();
  const [modal, setModal] = useState(false);

  const logoutModal = (e: any) => {
    e.preventDefault();
    setModal((modal) => !modal);
  };

  const { data } = useQuery({ queryKey: ['fetchCurrentUserDataCache'], queryFn: fetchCurrentUserData, });

  const refreshToken = localStorage.getItem("refreshToken");

  const logoutHandler = async () => {
    try {
      const response = await axiosInstance.post(`${backendbaseUrl}/users/logout/`, { refresh_token: refreshToken, }
      );
      if (response.status === 200) {
        toast.success(" Success...!");
        localStorage.removeItem("accessToken");
        localStorage.removeItem("refreshToken");
        localStorage.removeItem("resourceList");
        navigate(`/login`);
      }
    } catch (error: any) {
      if (error.response) {
        if (error.response.status === 401) {
          toast.error("Invalid Username or Password");
        } else {
          toast.error(
            error.response.data.message || "An unknown error occurred"
          );
        }
      } else {
        toast.error("Network error or server is down");
      }
    }
    setModal((modal) => !modal);
  };

  return (
    <LI className="profile-nav onhover-dropdown">
      <div className="onhover-click">
        <div className="sidebar-image">
          <Image src={dynamicImage(`user.png`)} alt="profile" />
          <span className="status status-success"></span>
        </div>
        <div className="sidebar-content">
          <H4>{data?.data?.name}</H4>
          <span className="f-12 f-w-600 f-light">{data?.data?.email}</span>
        </div>
      </div>
      <UL className="profile-dropdown onhover-show-div simple-list">
        {/* {profileHeaderData.map((item) => (
          <LI key={item.id}>
            <Link to={`${process.env.PUBLIC_URL}/${item.link}`}>
              <div className="profile-icon">
                <SvgIcon iconId={item.icon} />
              </div>
              <span>{item.text} </span>
            </Link>
          </LI>
        ))} */}
        <LI>
          {/* onClick={logout}  to={`${process.env.PUBLIC_URL}/login`} */}

          <Link to={""} color="primary" onClick={logoutModal}>
            <div className="profile-icon">
              <SvgIcon iconId="login" />
            </div>
            <span>{"Log out "}</span>
          </Link>

          <>
            <LogoutModal
              modalOpen={modal}
              toggle={logoutModal}
              logoutHandler={logoutHandler}
            />
          </>
        </LI>
      </UL>
    </LI>
  );
}
